<template>
    <v-row>
        <v-col cols="12" class="d-flex justify-space-between align-bottom flex-wrap">
            <v-text-field class="mr-3"
                          color="kbDarkBlue"
                          v-model="search"
                          append-icon="search"
                          :placeholder="$t('general.search')"
                          single-line
                          hide-details
                          clearable>
                <template slot="append-outer">
                    <v-icon class="ml-2" color="kbDarkBlue" @click="getInvitedUsers">refresh</v-icon>
                </template>
            </v-text-field>

            <div class="d-flex align-end flex-wrap">
                <v-btn outlined class="mr-2" color="kbPink">{{ $t('general.resendInvitations') }}</v-btn>
                <v-btn color="kbPink" dark @click="$emit('openSendSmsDialog', true)">
                    {{ $t('general.sendSms') }}
                </v-btn>
            </div>
        </v-col>

        <v-col cols="12">
            <v-data-table :headers="headers"
                          :items="invitedUsers"
                          class="elevation-2"
                          :loading="loadingInvitedUsers"
                          :options.sync="options"
                          :footer-props="{
                                            'items-per-page-text': `${$t('general.invitedPeople')} ${$t('general.perPage')}`,
                                            'items-per-page-options': [50, 100, 200]
                                          }"
                          :server-items-length="totalInvitedUsers"
                          :must-sort="false">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.name || $t('general.noName') }}</td>
                        <td>{{ item.email || $t('general.noEmail') }}</td>
                        <td>{{ item.phone || $t('general.noPhone') }}</td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingInvitedUsers">
                            {{ `${$t('general.loading')} ${$t('general.invitedPeople')}` }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noInvitationsSent') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      language: state => state.auth.language,
      loadingInvitedUsers: state => state.users.loadingInvitedUsers,
      paginationInvitedUsers: state => state.users.paginationInvitedUsers,
      totalInvitedUsers: state => state.users.totalInvitedUsers,
      invitedUsers: state => state.users.invitedUsers,
      selectedApp: state => state.apps.selectedApp
    }),
    search: {
      get () {
        return this.$store.state.users.searchInvited
      },
      set (value) {
        this.$store.commit('SET_SEARCH_INVITED_USERS', value)
      }
    }
  },
  data () {
    return {
      headers: [
        { text: this.$t('general.name'), value: 'name' },
        { text: 'Email', value: 'email' },
        { text: this.$t('general.phone'), value: 'phone' }
      ],
      options: {}
    }
  },
  methods: {
    getInvitedUsers () {
      this.$store.commit('SET_PAGINATION_INVITED_USERS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getInvitedUsers')
    },
    viewEvent (event) {
      this.$emit('viewEvent', event)
    },
    showNewEditEvent (event) {
      this.$emit('showNewEditEvent', event)
    }
  },
  watch: {
    language () {
      this.headers[0].text = this.$t('general.name')
      this.headers[2].text = this.$t('general.phone')
    },
    options: {
      handler () {
        this.getInvitedUsers()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getInvitedUsers()
    },
    selectedApp () {
      this.$store.dispatch('getInvitedUsers')
    }
  }
}
</script>
